// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/header/header.component.less
// module id = 507
// module chunks = 0